/*
 * @Author: wxb
 * @Date: 2021-11-17 11:19:53
 * @LastEditors: wxb
 * @LastEditTime: 2022-05-21 02:58:13
 * @Description:
 */
import request from '@/utils/request'
/**
 * @description: 报价单比对接口
 * @param {*} params
 * @return {*}
 */
export function quotationComparison(params) {
  return request({
    url: '/je/project/openi/general/quotation/compare/quotation/info',
    method: 'get',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
